var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOccurrencesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-megaphone-5279252",
    d: "M118.337,75.973l-.285.157h-6.381a7.27,7.27,0,0,0-1.111,14.31v5.209a3.333,3.333,0,1,0,6.667,0V90.63h.826l.285.157Zm12.222,12.873a5.583,5.583,0,0,0,0-10.931v-6.8a1.117,1.117,0,0,0-.546-.96,1.1,1.1,0,0,0-1.1-.017l-8.382,4.628a1.123,1.123,0,0,1,.029.253V91.746a1.123,1.123,0,0,1-.029.253l8.382,4.628a1.1,1.1,0,0,0,1.1-.017,1.117,1.117,0,0,0,.546-.96Z",
    transform: "translate(-105.004 -69.995)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccurrencesIcon);
export default __webpack_public_path__ + "static/media/occurrences_icon.2f30a31c64a9819ff2e7563c82b97676.svg";
export { ForwardRef as ReactComponent };